export const VerticalResizeSeparator = ({ id = "drag-bar", dir, isDragging, ...props }: any) => {
    return <div id={id} data-testid={id} className="w-2 shrink-0 cursor-ew-resize bg-transparent" {...props} />;
};
